export default __webpack_public_path__ + "static/media/logo-us-costco.d2eb00f4.svg";